var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-centered mt-200"},[_c('icon-default',{staticClass:"cancel_icon",attrs:{"icon":"check"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }